import { MicrosoftActionTypes, MicrosoftGraphAction } from './types';

export const setIsAuthenticated = (isAuthenticated: boolean): MicrosoftGraphAction => {
  return {
    type: MicrosoftActionTypes.SET_IS_AUTHENTICATED,
    isAuthenticated,
  }
};
